// Safety net for reports generated before the backend started emitting
// translated headings: rewrites known English headings/labels into the
// language the user is reading the app in.
const TRANSLATIONS = {
  pt: [
    ["Body Aesthetic Assessment Report", "Relatório de Avaliação Estética Corporal"],
    ["Facial Aesthetic Assessment Report", "Relatório de Avaliação Estética Facial"],
    ["Complete Body Evolutive Report", "Relatório Evolutivo Corporal Completo"],
    ["Complete Facial Evolutive Report", "Relatório Evolutivo Facial Completo"],
    ["This report is for informational and aesthetic purposes only. Consult a medical specialist.",
      "Este relatório é apenas informativo e estético. Consulte um(a) médico(a) especialista."],
    ["DISCLAIMER", "AVISO"],
    ["Identified Improvements", "Melhorias Identificadas"],
    ["Persistent or New Concerns", "Pontos Persistentes ou Novos"],
    ["Achievements and Highlights", "Conquistas e Destaques"],
    ["Prioritized Recommendations", "Recomendações Priorizadas"],
    ["General Conclusion", "Conclusão Geral"],
    ["Identified Concerns", "Pontos Identificados"],
    ["Recommended Treatments", "Tratamentos Recomendados"],
    ["Severity Level", "Nível de Intensidade"],
    ["Important Notes", "Observações Importantes"],
    ["Overview", "Visão Geral"],
    ["Timeline", "Linha do Tempo"],
    ["Assessment", "Avaliação"],
    ["Pronounced", "Acentuado"],
    ["Moderate", "Moderado"],
    ["Mild", "Leve"],
    ["BEFORE", "ANTES"],
    ["AFTER", "DEPOIS"],
  ],
  es: [
    ["Body Aesthetic Assessment Report", "Informe de Evaluación Estética Corporal"],
    ["Facial Aesthetic Assessment Report", "Informe de Evaluación Estética Facial"],
    ["Complete Body Evolutive Report", "Informe Evolutivo Corporal Completo"],
    ["Complete Facial Evolutive Report", "Informe Evolutivo Facial Completo"],
    ["This report is for informational and aesthetic purposes only. Consult a medical specialist.",
      "Este informe es solo informativo y estético. Consulta a un(a) médico(a) especialista."],
    ["DISCLAIMER", "AVISO"],
    ["Identified Improvements", "Mejoras Identificadas"],
    ["Persistent or New Concerns", "Puntos Persistentes o Nuevos"],
    ["Achievements and Highlights", "Logros y Destacados"],
    ["Prioritized Recommendations", "Recomendaciones Priorizadas"],
    ["General Conclusion", "Conclusión General"],
    ["Identified Concerns", "Puntos Identificados"],
    ["Recommended Treatments", "Tratamientos Recomendados"],
    ["Severity Level", "Nivel de Intensidad"],
    ["Important Notes", "Observaciones Importantes"],
    ["Overview", "Visión General"],
    ["Timeline", "Línea de Tiempo"],
    ["Assessment", "Evaluación"],
    ["Pronounced", "Acentuado"],
    ["Moderate", "Moderado"],
    ["Mild", "Leve"],
    ["BEFORE", "ANTES"],
    ["AFTER", "DESPUÉS"],
  ],
};

const escape = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const localizeReport = (text, language) => {
  const pairs = TRANSLATIONS[(language || "pt").split("-")[0]];
  if (!text || !pairs) return text;
  return pairs.reduce(
    (acc, [from, to]) => acc.replace(new RegExp(`\\b${escape(from)}\\b`, "g"), to),
    text,
  );
};
